import React from 'react'
import '../Styles/header.css'
const Header = () => {
 
    return (<>
  
        
        <div className='header-top'>
            <h1 className="top-text">O</h1>
            <p className="info-top">Ozodbek</p>
            <p>web developer</p>
        </div>
        <div className="navigation">
            <ul>
                <div className='link'>     <a href="#" >Work</a>      </div>
                <div className='link'>     <a href="#"> About Me</a>    </div>
                <div className='link'>     <a href="#">My Skills</a>  </div>
                <div className='link'>     <a href="">Blog</a>         </div>
                <div className='link'>     <a href="#">Contact me</a>  </div>
            </ul>
            <div className="icons-box">
                <h1><i className="fa-brands fa-github"></i></h1>
                <h1><i className="fa-brands fa-linkedin-in"></i></h1>
                <h1><i className="fa-brands fa-dribbble"></i></h1>
            </div>
        </div>
    </>)
}

export default Header;